import { render, staticRenderFns } from "./_user.fields.vue?vue&type=template&id=f29bf728&scoped=true&"
import script from "./_user.fields.vue?vue&type=script&lang=js&"
export * from "./_user.fields.vue?vue&type=script&lang=js&"
import style0 from "./_user.fields.vue?vue&type=style&index=0&id=f29bf728&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f29bf728",
  null
  
)

export default component.exports